<template>
  <div class="w-full justify-start items-start inline-flex bg-white" data-testid="table-loading-block">
    <div class="animate-pulse h-3 w-full bg-gray-200 rounded" />
  </div>
</template>
